var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYellowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.157 65.3789C122.157 96.6297 96.7995 121.976 65.505 121.976C34.2105 121.976 8.85352 96.6297 8.85352 65.3789C8.85352 34.1282 34.2105 8.78223 65.505 8.78223C96.7995 8.78223 122.157 34.1282 122.157 65.3789Z",
    stroke: "#FDDC2D",
    strokeWidth: 17
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCircle);
export default __webpack_public_path__ + "static/media/yellow-circle.d37607d6dea28b2414b65dfad11f98ab.svg";
export { ForwardRef as ReactComponent };